import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';

export const ATTEMPS_CONFIG: ModalErrorConfig = {
  imageUrl: {
    url: 'assets/img/errors/error__security.svg',
    altUrl: 'Information for error attemps icon/illustration',
  },
  errorTitle: 'Lo sentimos, no podemos atenderte ahora',
  errorDescription: 'Por favor, por tu seguridad, vuelve a intentar en 24 horas.',
  buttonLabel: 'Ir a la página principal',
};

export const ATTEMPS_CONFIG_FTD: ModalErrorConfig = {
  imageUrl: {
    url: 'assets/img/errors/error__security.svg',
    altUrl: 'Information for error attemps icon/illustration',
  },
  errorTitle: 'Lo sentimos, no podemos atenderte ahora',
  errorDescription: 'Por favor, por tu seguridad, vuelve a intentar en <strong>24 horas </strong>.',
  buttonLabel: 'Ir a la página principal',
};
